import { onDocumentEvent } from '@app/utils/domHelpers'

function handleToggleListClick(event) {
  event.preventDefault()

  const { target } = event

  const exportElement = target.closest('[data-behaviour~="export-element"]')
  const accountList = exportElement.querySelector(
    '[data-behaviour="export-accounts-list"]'
  )

  requestAnimationFrame(() => {
    accountList.classList.toggle('hidden')
    target.classList.toggle('muted')
  })
}

export default () =>
  onDocumentEvent(
    document,
    'click',
    '[data-behaviour="export-toggle-list"]',
    handleToggleListClick
  )
